export const TAB_SELECTED_INSTANCE_KEY = 'tab_selected_instance';
export const MOST_RECENTLY_SELECTED_INSTANCE_KEY = 'browser_selected_instance';
export function setSelectedInstanceStateForTab(selectedInstance) {
    sessionStorage.setItem(TAB_SELECTED_INSTANCE_KEY, selectedInstance);
}
export function setSelectedInstanceState(selectedInstance) {
    sessionStorage.setItem(TAB_SELECTED_INSTANCE_KEY, selectedInstance);
    localStorage.setItem(MOST_RECENTLY_SELECTED_INSTANCE_KEY, selectedInstance);
}
export function getSelectedInstanceState() {
    const sessionInstance = sessionStorage.getItem(TAB_SELECTED_INSTANCE_KEY);
    if (sessionInstance) {
        return sessionInstance;
    }
    return localStorage.getItem(MOST_RECENTLY_SELECTED_INSTANCE_KEY);
}
export function clearSelectedInstanceState() {
    sessionStorage.removeItem(TAB_SELECTED_INSTANCE_KEY);
    localStorage.removeItem(MOST_RECENTLY_SELECTED_INSTANCE_KEY);
}
//# sourceMappingURL=selectedInstanceHelper.js.map